// @flow
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import i18n from 'i18n-js';

import { GROUP_NETWORK_BANNERS } from '../NetworkBanner';

import * as actions from '../../actions/network';
import * as temporaryEventsActions from '../../actions/temporaryEvents';


const OFFLINE_BANNER = 'offlineBanner';
const ONLINE_BANNER = 'onlineBanner';


type NetworkListenerPropTypes = {
  onConnect: Function,
  onDisconnect: Function,
};


const NetworkListener = ({
  onConnect,
  onDisconnect,
}: NetworkListenerPropTypes) => {
  useEffect(() => {
    window.addEventListener('online', () => onConnect());
    window.addEventListener('offline', () => onDisconnect());

    return () => {
      window.removeEventListener('online', () => {});
      window.removeEventListener('offline', () => {});
    }
  }, []);

  return null;
};

export default connect(
  undefined,
  dispatch => ({
    onConnect() {
      dispatch(actions.connectNetwork());
      dispatch(temporaryEventsActions.complete(OFFLINE_BANNER));
      dispatch(actions.addBanner(
        ONLINE_BANNER,
        i18n.t('networkMessages.connectNetwork'),
        1, 6000,
      ));
      dispatch(temporaryEventsActions.trigger(ONLINE_BANNER));
    },
    onDisconnect() {
      dispatch(actions.disconectNetwork());
      dispatch(actions.addBanner(
        OFFLINE_BANNER,
        i18n.t('networkMessages.lostNetwork'),
        2,
      ));
    }
  })
)(NetworkListener);



// WEBPACK FOOTER //
// ./src/scripts/components/NetworkListener/index.jsx